<template>
  <tr :class="[{'active': active}]">
    <td>

      <div class="d-flex">

      
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <div>

          <div
          class="underline-link"
          @click.stop="$root.$timelineNav.open(item.id)">
            RID:
            {{ item.id }}
          </div>

          <br>

          <div v-if="item.batch_number" class="caption">
            <v-icon small>mdi-barcode</v-icon>
            {{ item.batch_number }}
          </div>

        </div>

      </div>

    </td>
    <td>
      <div class="caption">
        entered {{ dateOfEntryHuman }} <br /> ({{ dateOfEntry }})
      </div>

    </td>
    <td>
      <span v-if="item.inventory_instance_count === 0">
        ---
      </span>
      <template v-else>
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.total_stock"
        :key="item.id"
        alwaysScale
        labelMode
        ></c-ms-ii>

        <!--
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
            icon
            small
            color="color1"
            v-on="on"
            @click.stop="$emit('editQuantity', item.id)"
            >
              <v-icon color="orange" small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Error cos item may not actually be in inventory</span>
        </v-tooltip>
        -->
        
      </template>
    </td>
  </tr>
</template>

<script>
import Timeline from '../../timeline/Main'

export default {
  props: ['item', 'searchFilters', 'active'],
  components: {
    Timeline
  },
  data () {
    return {
      
    }
  },
  computed: {
    dateOfEntry () {
      if (this.$moment.utc(this.item.date_of_entry).isValid()) {
        return this.$moment(this.item.date_of_entry).format('DD MMM YYYY')
      }
      return ''
    },
    dateOfEntryHuman () {
      if (this.$moment.utc(this.item.date_of_entry).isValid()) {
        return this.$moment.utc(this.item.date_of_entry).fromNow()
      }
      return ''
    }
  }
}
</script>